export default __webpack_public_path__ + "static/media/sbn-logo.db1a047d.png";